export default __webpack_public_path__ + "static/media/square.33499394.svg";